export default {
    state: {}, // The backend will populate this with the actual feature flag values
}
